import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { protectedRoutes, routes } from './config/routes';
import MenuItemsLoader from './components/loading/menuLoader';
import { ProtectedRoute } from './components/protectedRoutes';
import { StatusPage } from './pages/status';
import { ObserverPage } from './pages/observer';
import { Toast } from './components/toast';
import { selectError } from './app/commonSlice';
import { useAppSelector } from './app/hooks';
import { useAppInit } from './hooks/useAppInit';

import './App.css';

const App: React.FunctionComponent = () => {
    const { isConfigReady, pathname } = useAppInit();
    const error = useAppSelector(selectError);

    if (pathname === '/status') {
        return <StatusPage />;
    }

    if (pathname === '/observer') {
        return <ObserverPage />;
    }

    if (!isConfigReady) {
        return <MenuItemsLoader />;
    }

    return (
        <div className='kitchen-wrapper'>
            <Routes>
                {routes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={<route.component name={route.name} />}
                    />
                ))}
                {protectedRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={<ProtectedRoute route={route} />}
                    />
                ))}
            </Routes>
            {error && <Toast message={error.message} />}
        </div>
    );
};

export default App;
